module.exports = __webpack_public_path__ + "img/product1.e56db0d5.png";